import React, { Component } from "react";
import { Animated } from "react-animated-css";

class ContactSection extends Component {
  render() {
    return (
      <div className="contactContainer">
        <h1 className="contactHeading">Contact</h1>
        <div className="contactInformation">
          <div>
            <i class="fas fa-envelope">
              <span className="grayColor">dylangardner157@gmail.com</span>
            </i>
          </div>
          <div>
            <i class="fas fa-mobile-alt">
              : <span className="grayColor">072 358 1764</span>
            </i>
          </div>
          <div id="section4">
            <a href="https://www.linkedin.com/in/dylan-gardner-7774b7136/">
              <i class="fab fa-linkedin">
                :<span className="grayColor"> Click to go to my Linkedin </span>
              </i>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactSection;
